module.exports = __webpack_public_path__ + "img/loginBg.979a2b94.jpg";